import { useContext } from "react";
import { Grid } from "@mui/material";
import { useAppDispatch, useAppSelector } from "../../../app/hooks";
import FormTable, {
  FormTableHeader,
} from "../../../common/components/functional/formTable/FormTable";
import { Talent, talentIsDeactivated } from "../../talents/talentAPI";
import {
  removeTalentCertificate,
  selectTalentById,
} from "../../talents/talentsSlice";
import { ContentKey } from "../TalentDetails";
import { AccessRightContext } from "../../user/AccessRightProvider";
import { useParams } from "react-router-dom";
import { DRIVING_LICENSES_CERT_TYPES, PASSPORT_CERT_TYPE } from "../constants";
import { CertificateValidTo } from "./CertificateValidTo";

type Props = {
  handleOpenEditModal: (content: ContentKey) => void;
  drivingLicenseMode?: boolean;
  headers: FormTableHeader[];
  contentKey: string;
  addButtonLabel: string;
};

const TalentCertificatesTable = ({
  handleOpenEditModal,
  drivingLicenseMode = false,
  headers,
  contentKey,
  addButtonLabel,
}: Props) => {
  const { canEditTalentProfile } = useContext(AccessRightContext);

  const { talentId } = useParams();
  const talent = useAppSelector(
    (state) => selectTalentById(state, talentId as string) as Talent,
  );

  const certificates =
    talent.certificates?.filter((cert) =>
      drivingLicenseMode
        ? DRIVING_LICENSES_CERT_TYPES.includes(cert.type)
        : !DRIVING_LICENSES_CERT_TYPES.includes(cert.type) &&
          cert.type !== PASSPORT_CERT_TYPE,
    ) || [];

  const translatedCertificates = useAppSelector(
    (state) => state.localized.certificate,
  );
  const dispatch = useAppDispatch();

  const handleDelete = (id: string) => {
    const certificate = certificates.find(
      (certificate) => certificate.id === id,
    );

    if (certificate) {
      const params = {
        id: certificate.id,
        version: certificate.version,
      };

      dispatch(removeTalentCertificate(params));
    }
  };

  const formattedCertificates = certificates
    .map(({ id, type, ...rest }) => ({
      values: {
        type: translatedCertificates[type],
        validTo: <CertificateValidTo certificate={rest} />,
      },
      deletable: true,
      id,
    }))
    .sort((a, b) => a.values.type.localeCompare(b.values.type)); // Sort alphabetically

  return (
    <Grid container columnSpacing={2}>
      <Grid
        item
        container
        xs={3}
        justifyContent="flex-end"
        alignItems="center"
      />
      <Grid item xs={9}>
        <FormTable
          data={formattedCertificates}
          headers={headers}
          contentKey={contentKey}
          translationKeys={["workTitle", "tes"]}
          handleOpenEditModal={handleOpenEditModal}
          addButtonLabel={addButtonLabel}
          handleDelete={(id) => handleDelete(id)}
          disableEditRow={!canEditTalentProfile || talentIsDeactivated(talent)}
        />
      </Grid>
    </Grid>
  );
};

export default TalentCertificatesTable;
